<template>
    <va-edit-layout>
        <AffordabilityExpenseReversalEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></AffordabilityExpenseReversalEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
